module.exports = __webpack_public_path__ + "static/media/p4_img2.810ee310.svg";